<template>
  <div id="app">
    <div class="wrapper">
      <header>
        <HeaderLayout />
      </header>
      <main
        class="flex flex-col"
        :class="{
          'space-y-24 sm:space-y-32': initialStep === 0,
          'space-y-12 sm:space-y-16': initialStep > 0,
        }"
      >
        <HeroSection @launchAgent="launchAgent" v-show="initialStep === 0" />
        <JobAgentSection :initial-step="initialStep" @changeStep="changeStep" />
        <UspSection @launchAgent="launchAgent" v-show="initialStep === 0" />
      </main>
      <footer class="flex justify-center w-full mt-12">
        <div>
          <FooterLayout />
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import HeaderLayout from "@/components/layout/HeaderLayout";
import FooterLayout from "@/components/layout/FooterLayout";

import HeroSection from "@/components/section/HeroSection";
import JobAgentSection from "@/components/section/JobAgentSection";
import UspSection from "@/components/section/UspSection";

import { initTracking, addTrackingParamToURL } from "@/utils/tracking.js";

export default {
  name: "App",
  components: {
    HeaderLayout,
    FooterLayout,
    HeroSection,
    JobAgentSection,
    UspSection,
  },
  data() {
    return {
      initialStep: 0,
    };
  },
  methods: {
    launchAgent() {
      this.initialStep = 1;
    },
    changeStep(nextStep) {
      this.initialStep = nextStep;
    },
    getTrackingURL(url) {
      return addTrackingParamToURL(url);
    },
  },
  created() {
    initTracking();
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "XING Sans Regular";
  font-weight: normal;
  src: url("assets/fonts/XING-Sans-Regular.woff2");
}

@font-face {
  font-family: "XING Sans Bold";
  font-weight: bold;
  src: url("assets/fonts/XING-Sans-Bold.woff2");
}

h1,
h2,
h3,
h4,
.font-bold,
.cta-button {
  font-family: "XING Sans Bold";
}

#app {
  @apply flex justify-center w-full;
  font-family: "XING Sans Regular", Trebuchet MS, Arial, Helvetica Neue,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1d2124;
  overflow: hidden;
  font-size: 18px;
  line-height: 25px;

  & .wrapper {
    @apply w-full;

    & header,
    & main,
    & footer {
      @apply w-full;
    }
  }

  & .content-wrapper {
    padding: 0 15px;
  }

  & mark {
    background-position: 0 85%;
    background-size: 50% 20%;
    background-image: linear-gradient(transparent 0, #c6f16d 0);
    background-repeat: repeat-x;
    background-color: transparent;
    color: inherit;
    padding-left: 0.2em;
    padding-right: 0.2em;
  }

  & h1 {
    font-weight: bold;
    font-size: 42px;
    line-height: 50px;
  }

  & h2 {
    font-weight: bold;
    font-size: 32px;
    line-height: 38px;
  }

  & h3 {
    font-weight: bold;
    font-size: 20px;
    line-height: 25px;
  }
}

@media (min-width: 320px) {
  #app {
    & .content-wrapper {
      max-width: 335px;
    }
  }
}

@media (min-width: 400px) {
  #app {
    & .content-wrapper {
      max-width: 415px;
    }
  }
}

@media (min-width: 640px) {
  #app {
    & .content-wrapper {
      max-width: 655px;
    }
  }
}

@media (min-width: 940px) {
  #app {
    & .content-wrapper {
      max-width: 955px;
    }
  }
}

@media (min-width: 960px) {
  #app {
    & .content-wrapper {
      max-width: 975px;
    }

    & h1 {
      font-size: 48px;
      line-height: 60px;
    }

    & h2 {
      font-size: 33px;
      line-height: 40px;
    }

    & h3 {
      font-size: 24px;
      line-height: 30px;
    }
  }
}
</style>
